import { DataQuoteStateType } from "../typesCollapseQuote";
import * as S from "./styles";
import ColumnLabel from "@/main/components/common/columnLabel/columnLabel";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import CopyToClipboardText from "@/main/components/shared/copyToClipboardText/copyToClipboardText";

interface IHeaderCollapseQuoteProps {
	dataQuote: DataQuoteStateType;
}
function HeaderCollapseQuote({ dataQuote }: IHeaderCollapseQuoteProps) {
	if (isNullUndefined(dataQuote)) return null;

	return (
		<S.Container>
			<ColumnLabel
				label={getTranslateByKey("information.vin")}
				content={
					<CopyToClipboardText
						label={getTranslateByKey("information.vin")}
						valueToCopy={dataQuote.vehicleVIN ? dataQuote.vehicleVIN : ""}
					>
						{dataQuote.vehicleVIN}
					</CopyToClipboardText>
				}
			/>
		</S.Container>
	);
}

export default HeaderCollapseQuote;
